import { render } from "./LbrxCartItem.vue?vue&type=template&id=2490a37f"
import script from "./LbrxCartItem.vue?vue&type=script&lang=js"
export * from "./LbrxCartItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__